import { render, staticRenderFns } from "./PlcNotice.vue?vue&type=template&id=6b5fc382&scoped=true"
import script from "./PlcNotice.vue?vue&type=script&lang=js"
export * from "./PlcNotice.vue?vue&type=script&lang=js"
import style0 from "./PlcNotice.vue?vue&type=style&index=0&id=6b5fc382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5fc382",
  null
  
)

export default component.exports